__turbopack_context__.v({
  "container": "style-module-scss-module__sB20GW__container",
  "searchButton": "style-module-scss-module__sB20GW__searchButton",
  "searchForm": "style-module-scss-module__sB20GW__searchForm",
});
